
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import Img1 from "./img/1.webp";
import Img2 from "./img/Mur tendu imprimé design avec motifs de feuilles artistiques dans un salon contemporain – solution décorative Unik System.webp";

const carouselItems = [
  {
  img: Img1,
  subtitle: (
    <>
      <span className="subtitle-us">US</span> WALLDRESS
    </>
  ),
  title: "Habillage Mural Haut de Gamme",
  text: "Apportez du caractère à vos espaces avec des revêtements muraux élégants, combinant textures modernes et finitions premium."
},
{
  img: Img2,
  subtitle: (
    <>
      <span className="subtitle-us">US</span> ARTFLOW
    </>
  ),
  title: "Design Artistique Fluide & Moderne",
  text: "Des créations décoratives aux lignes organiques qui donnent mouvement, harmonie et identité unique à vos espaces."
}
  
];


const HeaderCarousel = () => {
  return (
    <div className="container-fluid p-0" id="section1">

      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        loop={true}
        autoplay={{
          delay: 8000,
          disableOnInteraction: false,
        }}
      >
        {carouselItems.map((item, index) => (
          <SwiperSlide key={index}>
                      <div className="position-relative">
          
                        {/* IMAGE */}
                        <img className="w-100 hero-img" src={item.img} alt={item.alt} loading="lazy"/>
          
                        {/* OVERLAY */}
                        <div className="hero-overlay d-flex align-items-center">
                          <div className="container">
                            <div  className="col-12 col-lg-8">
          
                              <h5 className="text-uppercase mb-2 text-white fw-bold tracking-in">
                                {item.subtitle}
                              </h5>
          
                              <h1 className="display-3 fw-bold text-white mb-4 slide-down" >
                                {item.title}
                              </h1>
          
                              <p className="fs-5 text-white mb-4 slide-up">
                                {item.text}
                              </p>
          
                              <a href="#titre-gallry" className="btn py-md-3 px-md-5 me-3 slide-left" id="pmt-link">
                                Voir nos réalisations
                              </a>
          
                              <a href="/devis" className="btn py-md-3 px-md-5 slide-left" id="pmt-link2">
                                Demander un devis
                              </a>
          
                            </div>
                          </div>
                        </div>
          
                      </div>
                    </SwiperSlide>
        ))}
      </Swiper>

    </div>
  );
};

export default HeaderCarousel;

